{
  "titles": {
    "login": "Aanmelden",
    "developerTool": "Developer Autorisatie Tool"
  },
  "fields": {
    "labels": {
    "email": "E-mail",
    "password": "Wachtwoord"
  },
    "placeholders": {
      "email": "Vul je email in"
    }
  },
  "actions": {
    "login": "Inloggen",
    "clearOverrides": "Reset overschrijvingen",
    "close": "Sluiten"
  },
  "developerTool": {
    "description": "Met deze tool kun je tijdelijk rollen, permissies en feature flags aan- en uitzetten voor test doeleinden. Let op: dit werkt alleen in de front-end, de backend controleert nog steeds alle rechten.",
    "warning": "Deze overschrijvingen worden gereset wanneer je token wordt vernieuwd.",
    "resetIn": "Reset over",
    "tabs": {
      "permissions": "Permissies",
      "roles": "Rollen",
      "featureFlags": "Feature Flags"
    },
    "active": "Actief",
    "inactive": "Inactief"
  }
}